export interface User {
  id: string;
  firstName: string;
  lastName: string;
  fullName: string;
  email: string;
  phoneNumber?: string;
  mxWarehouseId?: number | string;
  mxUbiId?: number;
  userName: string;
  password?: string;
  confirmPassword: string;
  role: string;
  roles: string[];
}

/**
 * Solo due ruoli: l'amministratore, che governa listini e oneri (cioè quanto si fattura),
 * e l'operatore, che fa il lavoro quotidiano su contratti, movimenti, M.A.D. e buoni.
 */
export enum UserRoles {
  Admin = "Admin",
  User = "User"
}